import CreditFlowResearchRepository from '@/creditflowresearch/infrastructure/repository/CreditFlowResearchRepository';
import { getUrlAndDownloadAttachment } from '@/creditflowresearch/application/helpers';
import { AlertManager } from '@creditflowresearch/uilib/Alert';
import { getErrorMessage } from '@framework/message/Mapper/getMessage';
import { getContainer } from '@framework/di/getContainer';

const useDownloadAttachment = () => {
  const container = getContainer();
  const downloadAttachment = async (
    { displayName, uploadId }: { displayName: string, uploadId: string },
  ) => {
    const cfrRepository = container.get<CreditFlowResearchRepository>(CreditFlowResearchRepository);
    try {
      await getUrlAndDownloadAttachment(cfrRepository.getAttachmentDownloadUrl, { displayName, uploadId });
    } catch (error) {
      AlertManager.error(getErrorMessage(error));
    }
  };
  return { downloadAttachment };
};

export default useDownloadAttachment;
